import Dexie from "dexie";

export const productDB = new Dexie("ProductDB");

productDB.version(1).stores({
  products: "sku_code",
  meta: "key",
});